import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { StoreTour } from './pages/StoreTour';
import { Firearms } from './pages/Firearms';
import { Ammunition } from './pages/Ammunition';
import { Optics } from './pages/Optics';
import { ReloadingSupplies } from './pages/ReloadingSupplies';
import { SafesAccessories } from './pages/SafesAccessories';
import { HuntingGearBlinds } from './pages/HuntingGearBlinds';
import { Services } from './pages/Services';
import { PermitToCarry } from './pages/PermitToCarry';
import { Events } from './pages/Events';
import { FAQ } from './pages/FAQ';
import { Contact } from './pages/Contact';
// New Pages
import { SuppressorsNFA } from './pages/SuppressorsNFA';
import { Gunsmithing } from './pages/Gunsmithing';
import { ThermalOptics } from './pages/ThermalOptics';
import { FirearmTransfers } from './pages/FirearmTransfers';
import { UsedGunsEstates } from './pages/UsedGunsEstates';
import { BanquetsFundraisers } from './pages/BanquetsFundraisers';
import { Brands } from './pages/Brands';
import { GunBrokerListings } from './pages/GunBrokerListings';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<About data-id="element-6" />} data-id="element-5" />
          <Route path="/store-tour" element={<StoreTour data-id="element-8" />} data-id="element-7" />
          <Route path="/firearms" element={<Firearms data-id="element-10" />} data-id="element-9" />
          <Route path="/ammunition" element={<Ammunition data-id="element-12" />} data-id="element-11" />
          <Route path="/optics" element={<Optics data-id="element-14" />} data-id="element-13" />
          <Route path="/reloading-supplies" element={<ReloadingSupplies data-id="element-16" />} data-id="element-15" />
          <Route path="/safes-accessories" element={<SafesAccessories data-id="element-18" />} data-id="element-17" />
          <Route path="/hunting-gear-blinds" element={<HuntingGearBlinds data-id="element-20" />} data-id="element-19" />
          <Route path="/services" element={<Services data-id="element-22" />} data-id="element-21" />
          <Route path="/mn-permit-to-carry-classes" element={<PermitToCarry data-id="element-24" />} data-id="element-23" />
          <Route path="/events" element={<Events data-id="element-26" />} data-id="element-25" />
          <Route path="/faq" element={<FAQ data-id="element-28" />} data-id="element-27" />
          <Route path="/contact" element={<Contact data-id="element-30" />} data-id="element-29" />

          {/* New Routes */}
          <Route path="/nfa-process" element={<SuppressorsNFA data-id="element-32" />} data-id="element-31" />
          <Route path="/gunsmithing" element={<Gunsmithing data-id="element-34" />} data-id="element-33" />
          <Route path="/thermal-optics" element={<ThermalOptics data-id="element-36" />} data-id="element-35" />
          <Route path="/firearm-transfers" element={<FirearmTransfers data-id="element-38" />} data-id="element-37" />
          <Route path="/used-guns-appraisals-estates" element={<UsedGunsEstates data-id="element-40" />} data-id="element-39" />
          <Route path="/banquets-fundraisers" element={<BanquetsFundraisers data-id="element-42" />} data-id="element-41" />
          <Route path="/brands" element={<Brands data-id="element-44" />} data-id="element-43" />
          <Route path="/gunbroker-listings" element={<GunBrokerListings data-id="element-46" />} data-id="element-45" />
        </Routes>
      </Layout>
    </Router>;
}